import { App } from "./core";

import "./style/index.css";

export default App;
